<template>
  <div>
    <van-dialog v-model:show="showCarInfo" title="提示" show-cancel-button cancelButtonText="返回查看我的车辆"
      confirmButtonText="确认使用" cancelButtonColor="#000" @cancel="viewCarList" @confirm="confirm">
      <div v-for="item in compareCarInfo" :key="item.title" class="popUpInfo">
        <div class="title">{{ item.title }}</div>
        <div>
          <span class="key">车牌：</span><span :class="{ diffrent: item.info.plateDiff }">{{ item.info.plate }}</span>
        </div>
        <div>
          <span class="key">VIN：</span><span :class="{ diffrent: item.info.vinDiff }">{{ item.info.vin }}</span>
        </div>
        <div>
          <span class="key">底盘号：</span><span :class="{ diffrent: item.info.finDiff }">{{ item.info.fin }}</span>
        </div>
        <!-- <div>
          <span class="key">三包日期：</span><span :class="{ diffrent: item.info.dateDiff }">{{ item.info.threeGuaranteesDate }}</span>
        </div> -->
      </div>
      <div class="tip">是否确认使用已有车辆信息购买</div>
    </van-dialog>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { Toast } from 'vant'
import { addFromQr, updateCarInfo } from '@/api/car'
import { compareCarInfoFn } from '@/util/car'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  setup(_, { emit }) {
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      showCarInfo: false,
      currentCarInfo: {},
      compareCarInfo: []
    })
    const viewCarList = () => {
      router.push({
        path: '/carList',
        query: {
          callBack: true,
          event: '返回查看我的车辆'
        }
      })
    }
    const confirm = async () => {
      store.dispatch('setCurrentCarInfo', state.currentCarInfo)
      let params = state.currentCarInfo
      if (!params.defaultFlag) {
        params.defaultFlag = true
        await updateCarInfo(params)
        Toast({ message: '车辆信息更新成功', position: 'bottom' })
      }
    }
    const createCarInfo = async carInfo => {
      // console.log('carInfo',store.state.showdiffCarTip,carInfo)
      if (store.state.showdiffCarTip) {
        store.commit('SETSHOWDIFFCARTIP', false)
      } else {
        return
      }
      let data = JSON.parse(carInfo)
      data.defaultFlag = true
      let params = data
      try {
        let backCarInfo = await addFromQr(params)
        let len = backCarInfo.length
        if (len === 2) {
          state.showCarInfo = true
          state.compareCarInfo = compareCarInfoFn(backCarInfo)
          state.currentCarInfo = backCarInfo.find(item => item.status === 2).carInfo
          // emit('custom-event', true);
        } else if (len === 1) {
          await store.dispatch('setCurrentCarInfo', backCarInfo[0].carInfo)
          // console.log('setCurrentCarInfo', backCarInfo)

          Toast({
            message: '车辆信息更新成功',
            position: 'bottom',
            duration: 2000,
            onClose: () => {
              store.dispatch('setCurrentCarInfo', backCarInfo[0].carInfo)
            }
          })
          // emit('custom-event', true);
        } else {
          emit('custom-event', false);
          // console.log('setCurrentCarInfo', backCarInfo)
          Toast({ message: '车辆信息更新失败', position: 'bottom' })
          store.dispatch('setCurrentCarInfo', '')
        }
      } catch (error) {
        emit('custom-event', false);
        Toast({ message: error.message, position: 'bottom', duration: 3000 })
        store.dispatch('setCurrentCarInfo', '')
      } finally {
        emit('custom-event-over', true);
      }
    }
    return {
      ...toRefs(state),
      createCarInfo,
      viewCarList,
      confirm
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  margin: 20px;
  font-size: 12px;
  color: #f49b55;
}

.popUpInfo {
  padding: 20px 20px 0;
  font-size: 12px;
  line-height: 1.4;

  .title {
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .diffrent {
    color: #3088c5;
  }

  .key {
    display: inline-block;
    width: 65px;
    text-align: left;
  }
}
</style>
